import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import AulaEditorWithAnalytics from '@app/components/presentational/common/AulaEditor/AulaEditorWithAnalytics';
import { API_URL, FILE_URL } from '@core/constants/endpoints';
import { isInstructor } from '@core/selectors/classroom';
import { getMaterialPlacementLtiProviders } from '@core/selectors/lti';
import {
  accessToken as getAccessToken,
  currentUser,
} from '@core/selectors/user';
import { AulaState } from '@core/types/state';

type ResponsiveEditorReadOnlyProps = {
  editorState: Record<string, unknown>;
  itemId: string;
  itemType: string;
};

const ResponsiveEditorReadOnly = ({
  editorState,
  itemId,
  itemType,
}: ResponsiveEditorReadOnlyProps) => {
  const user = useSelector(currentUser);
  const spaceId = useSelector((state: AulaState) => state.classRoom.current);
  const accessToken = useSelector((state: AulaState) =>
    getAccessToken(state, spaceId)
  );
  const institution = useSelector(
    (state: AulaState) => state.institution.general.institution
  );
  const isEducator = useSelector((state: AulaState) =>
    isInstructor(state, state.user?.userId)
  );
  const ltiProviders = useSelector(getMaterialPlacementLtiProviders);

  const editorConfig = useMemo(
    () => ({
      filesUrl: FILE_URL(),
      apiUrl: API_URL(),
      accessToken,
      spaceId,
      institution,
      userId: user?.objectId,
      ltiProviders,
      itemType,
      itemId,
      isEducator,
    }),
    [
      accessToken,
      institution,
      isEducator,
      itemId,
      itemType,
      ltiProviders,
      spaceId,
      user?.objectId,
    ]
  );

  if (!user) return null;

  return (
    <AulaEditorWithAnalytics
      readOnly
      editorState={editorState}
      config={editorConfig}
      isAssignmentsEnabled
    />
  );
};

export default ResponsiveEditorReadOnly;
